// extracted by mini-css-extract-plugin
module.exports = {"container":"footer__container___2XPTj","text":"footer__text___rA15D"};